import { useLazyQuery } from '@apollo/client';
import React, { createContext, useMemo, useCallback } from 'react';
import { NULL_USER } from '../../lib/user';
import { useUser } from '../../hooks/useUser';
import { GET_FAVORITES_QUERY } from './favorites.rest';

// creating a React context for favorites to fix performance problems caused by using a useQuery in every VariantCell
export const FavoritesContext = createContext({
  user: NULL_USER,
  favorites: [] as number[],
  getFavorites: () => {
    return;
  },
  loaded: false
});

export const FavoritesProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { user } = useUser();
  // remove { ssr: false } from this once https://github.com/apollographql/apollo-client/issues/9108 is resolved
  const [fetchFavorites, { data, called }] = useLazyQuery(GET_FAVORITES_QUERY, { ssr: false });

  const favorites = useMemo(() => data?.userFavorites.data.attributes.variantIds || [], [data]);

  const getFavorites = useCallback(
    () => user.isLoggedIn && !called && fetchFavorites(),
    [user.isLoggedIn, fetchFavorites, called]
  );

  return (
    <FavoritesContext.Provider value={{ user, favorites, getFavorites, loaded: data != null }}>
      {children}
    </FavoritesContext.Provider>
  );
};
